import * as React from "react";
import { DisabledButtonStyle, DisabledLightGreyButtonStyle, DisabledMutedGreyButtonStyle } from "./Styles";
import { HtmlTooltip, HtmlTooltipDisabled } from "../StyledComponents/styled";

export default function DisabledButton({ label, onClick, icon, toolTipContent, ariaText }) {
  return (
    <HtmlTooltip title={toolTipContent}>
      <DisabledButtonStyle
        component={"a"}
        aria-label={typeof ariaText !== "undefined" ? ariaText : label}
        variant="outlined"
        onClick={onClick}
        startIcon={icon}
      >
        {label}
      </DisabledButtonStyle>
    </HtmlTooltip>
  );
}

export const DisabledGreyButton = ({ label, onClick, icon, toolTipContent, ariaText, sx }) => {
  return (
    <HtmlTooltip title={toolTipContent}>
      <DisabledLightGreyButtonStyle
        component={"button"}
        aria-label={typeof ariaText !== "undefined" ? ariaText : label}
        variant="contained"
        onClick={onClick}
        startIcon={icon}
        sx={{ ...sx }}
      >
        {label}
      </DisabledLightGreyButtonStyle>
    </HtmlTooltip >
  );
};

// Same shape as the primary action buttons, but rendered in a muted grey with the
// grey (disabled) tooltip, so a locked action stays visible without looking clickable.
export const DisabledMutedGreyButton = ({ label, onClick, icon, toolTipContent, ariaText, sx }) => {
  return (
    <HtmlTooltipDisabled title={toolTipContent}>
      <DisabledMutedGreyButtonStyle
        component={"button"}
        aria-label={typeof ariaText !== "undefined" ? ariaText : label}
        aria-disabled={true}
        variant="contained"
        onClick={onClick}
        startIcon={icon}
        sx={{ ...sx }}
      >
        {label}
      </DisabledMutedGreyButtonStyle>
    </HtmlTooltipDisabled>
  );
};
